import { styled } from '@mui/system';
import MuiCard from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import MuiAppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';

export const CardWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(1, 1, 5, 1)
}));

export const Card = styled(MuiCard)(({ theme }) => ({
  width: '90%',
  height: '150px',
  margin: '-90px auto 0 auto',
  borderRadius: '20px',
  cursor: 'pointer',
  boxShadow: '0px 0px 25px -12px rgba(0, 0, 0, 0.658)',
  '&:first-of-type': {
    marginTop: theme.spacing(2)
  }
}));

export const StyledCardContent = styled(CardContent)({
  display: 'flex',
  justifyContent: 'space-between'
});

export const CardHeaderText = styled(Typography)({
  fontSize: '1.1rem',
  fontWeight: 500,
  padding: '0 5px'
});

export const CardIdentifiers = styled(Typography)(({ theme }) => ({
  fontSize: '1.1rem',
  fontWeight: 500,
  padding: '0 5px',
  display: 'flex',
  alignItems: 'center',
  '& svg': {
    marginRight: theme.spacing(1.5),
    paddingBottom: '2px'
  }
}));

export const LoadingWrapper = styled('div')({
  fontSize: '1.1rem',
  fontWeight: 500,
  padding: '0 5px'
});

export const NoLocations = styled('div')({
  marginTop: 50,
  textAlign: 'center',
  '& h4': {
    color: '#667'
  }
});

export const ProgressBarContainer = styled('button')({
  marginTop: '10px',
  padding: '0 30px',
  border: 'none',
  width: '100%',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#EEE'
  },
  '&:focus': {
    outline: 'none',
    backgroundColor: '#EEE'
  }
});

export const DialogAppBar = styled(MuiAppBar)({
  position: 'fixed',
  backgroundColor: 'black',
  color: 'white'
});

export const StyledCloseIcon = styled(IconButton)({
  position: 'absolute',
  right: 0,
  color: '#FFF'
});

export const EventsWrapper = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    marginTop: 0
  }
}));
